export const deepEqual = (object1, object2) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if (
            areObjects && !deepEqual(val1, val2) ||
            !areObjects && val1 !== val2
        ) {
            return false;
        }
    }
    return true;
}

const isObject = (object) => {
    return object != null && typeof object === 'object';
}


export const hasDuplicates = (arr) => {
    return new Set(arr).size !== arr.length;
}

export const isNormalInteger = (str) => {
    if (!str) {
        return false;
    }
    str = str.trim();
    str = str.replace(/^0+/, "") || "0";
    var n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= 0;
}

export const isPositiveFloat = (s) => {
    return !isNaN(s) && Number(s) > 0;
}

export function isNumber(n) { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); } 